import {Component, HostListener, OnInit} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {HeaderComponent} from './header/header.component';
import {SidebarComponent} from './sidebar/sidebar.component';
import {CommonModule} from '@angular/common';
import {FooterComponent} from './footer/footer.component';
import {VisionConfigService} from '../services/vte/vision-config.service';
// import { Router, NavigationEnd } from '@angular/router';
// import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-layout',
    imports: [RouterOutlet, HeaderComponent, SidebarComponent, FooterComponent, CommonModule],
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.css']
})
export class LayoutComponent implements OnInit {
  sidebarOpen = false;
  // isMobile = window.innerWidth <= 768;
  isMobile = window.innerWidth <= 768;
  currentPageTitle = 'Dashboard'; // default

    constructor(private visionConfig: VisionConfigService) {
    }

    ngOnInit(): void {
        this.visionConfig.loadForCurrentOrganization(true).subscribe();
    }

  // ngOnInit() {
  //   this.router.events
  //     .pipe(filter((event) => event instanceof NavigationEnd))
  //     .subscribe(() => {
  //       const currentUrl = this.router.url;
  //       if (currentUrl.includes('/vehicle')) {
  //         this.currentPageTitle = 'Vehicle Database';
  //       } else if (currentUrl.includes('/reports')) {
  //         this.currentPageTitle = 'Reports';
  //       } else if (currentUrl.includes('/profile')) {
  //         this.currentPageTitle = 'Profile';
  //       }else if (currentUrl.includes('/organization')) {
  //         this.currentPageTitle = 'Organization';
  //       }  else {
  //         this.currentPageTitle = 'Dashboard';
  //       }
  //     });
  // }

  /** Keep `isMobile` up-to-date when the user resizes */
  @HostListener('window:resize')
  onResize() {
    this.isMobile = window.innerWidth <= 768;
  }

  toggleSidebar() {
    this.sidebarOpen = !this.sidebarOpen;
  }
   handleSidebarLink() {
    if (this.isMobile) {
      this.sidebarOpen = false;
    }
  }
}
